module.exports = __webpack_public_path__ + "static/media/machine-occupied.ccb99c0d.svg";